import { AEMLink } from '@msc-b2c/interfaces/types';
import { DIRECT_LOGIN_TYPE, DirectLoginParams } from './useDirectLogin';
import { getQueryParamIgnoreCase } from '@msc-b2c/shared-utils';

export const retrieveDirectLoginQueryParams = () => {
  return {
    name: getQueryParamIgnoreCase(globalThis.location.search, 'fname')?.replaceAll(
      /\+/g,
      ' '
    ) as string,
    surname: getQueryParamIgnoreCase(globalThis.location.search, 'lname')?.replaceAll(
      /\+/g,
      ' '
    ) as string,
    bookingNumber: getQueryParamIgnoreCase(globalThis.location.search, 'bkgnb') as string,
    bf: getQueryParamIgnoreCase(globalThis.location.search, 'bf') as string,
    serviceType: getQueryParamIgnoreCase(globalThis.location.search, 'serviceType') as string,
    itemCode: getQueryParamIgnoreCase(globalThis.location.search, 'itemCode') as string,
    signature: getQueryParamIgnoreCase(globalThis.location.search, 'signature') as string,
    signatureDate: getQueryParamIgnoreCase(globalThis.location.search, 'signatureDate') as string,
    cruiseId: getQueryParamIgnoreCase(globalThis.location.search, 'cruiseId') as string,
    dob: getQueryParamIgnoreCase(globalThis.location.search, 'dob') as string,
  } as DirectLoginParams;
};

export const retrieveURLByServiceType = (mapperURLs: any[], serviceType: string) => {
  if (!mapperURLs.length) return undefined;

  const routeObj = mapperURLs.find((u) => !!u.routeTypes[serviceType]);
  const url = (!!routeObj && routeObj.routeUrl) || undefined;
  if (!!url && url.valid) {
    return url.url;
  }

  return undefined;
};

export const getDEMRedirectURL = (
  fallbackLink: AEMLink,
  prepaidPagesMappedURLs: [],
  serviceType: string
): string | undefined => {
  const url = retrieveURLByServiceType(prepaidPagesMappedURLs, serviceType);

  const fallbackUrl = !!fallbackLink && fallbackLink.valid ? fallbackLink?.url : undefined;

  return url ?? fallbackUrl;
};

export const retrieveDirectLoginType = (params: DirectLoginParams) => {
  const { name, surname, bookingNumber, bf, serviceType, signature, signatureDate, cruiseId, dob } =
    params;

  const hasCommonParams = !!name && !!surname && !!bookingNumber && !!dob;

  if (!hasCommonParams) return DIRECT_LOGIN_TYPE.NONE;

  if (bf) return DIRECT_LOGIN_TYPE.BF;

  const isDEMLogin = !!cruiseId && !!serviceType && !!signature && !!signatureDate;

  if (isDEMLogin) return DIRECT_LOGIN_TYPE.DEM;

  return DIRECT_LOGIN_TYPE.NONE;
};
